export default "__VITE_ASSET__CQwj8xdZ__"